export const APP_CONFIG = {
  name: 'SignalNear',
  tagline: 'Live Local Alerts & Disruption Radar',
  version: '1.0.0',
  canonicalUrl: 'https://signalnear.pages.dev',
  
  // NWS Integration
  nws: {
    baseUrl: 'https://api.weather.gov',
    alertsEndpoint: '/alerts/active',
    // Contact string according to NWS web API guidelines: ApplicationName/Version (contact-email)
    userAgent: 'SignalNear-DisruptionRadar/1.0 (contact@signalnear.org)',
    requestTimeoutMs: 12000,
    pollingIntervalMinutes: 2,
    cacheTtlSeconds: 120, // 2 minutes
    staleTtlSeconds: 600, // 10 minutes - if older, flag as stale
  },

  // International status - Explicit, honest state
  supportedRegions: [
    { code: 'US', name: 'United States', status: 'active', source: 'National Weather Service (weather.gov)' },
    { code: 'UK', name: 'United Kingdom', status: 'coming-soon', note: 'Met Office data integration under architectural review' },
    { code: 'CA', name: 'Canada', status: 'coming-soon', note: 'Environment and Climate Change Canada integration under review' },
    { code: 'AU', name: 'Australia', status: 'coming-soon', note: 'Bureau of Meteorology data integration under review' },
  ],

  // Monetization flags (Zero upfront cost, fully disabled by default until verified approval)
  monetization: {
    adsense: {
      enabled: Boolean(import.meta.env.VITE_ADSENSE_CLIENT_ID),
      clientId: import.meta.env.VITE_ADSENSE_CLIENT_ID || '', // Never fabricate!
      testMode: import.meta.env.DEV,
    },
    affiliates: {
      enabled: import.meta.env.VITE_AFFILIATES_ENABLED === 'true',
      partner: 'EmergencyPreparednessNetwork',
    }
  },

  // Organization & Legal
  contact: {
    email: import.meta.env.VITE_CONTACT_EMAIL || 'contact@signalnear.org',
    inquiries: 'support@signalnear.org',
  }
};

